import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const staticMaterialStatusEnumSchema = z.enum([
    'completed',
]);

export const updateMaterialStatusCfgSchema = baseNodeCfgSchema.extend({
    controlValues: z.object({
        status: staticMaterialStatusEnumSchema,
    }),
    kind: z.literal('updateMaterialStatus'),
});
interface UpdateMaterialStatusCfgSchema extends z.infer<typeof updateMaterialStatusCfgSchema> {}

export const updateMaterialStatusSocketCfg = {
    controlSockets: {
        outputs: () => ({ next: 'event' }),
        inputs: () => ({ trigger: 'event' }),
    },
    dataSockets: {
        outputs: () => ({}),
        inputs: () => ({
            materialId: 'string',
        }),
    },
} satisfies NodeSocketCfg<UpdateMaterialStatusCfgSchema>;
